import * as React from 'react';

import swirlsTop from './assets/swirls-top.svg';
import { LandingCarousel } from './components/landing-carousel/LandingCarousel';
import { LandingHeader } from './components/landing-header/LandingHeader';
import { LandingNeedHelp } from './components/landing-need-help/LandingNeedHelp';
import { LandingWelcome } from './components/landing-welcome/LandingWelcome';
import styles from './LandingPage.module.css';

const LandingPage = React.memo((): React.ReactElement => {
  return (
    <div className={styles.landingPage} data-testid="landing-page">
      <img
        src={swirlsTop}
        className={styles.swirlsTop}
        aria-hidden="true"
        data-testid="swirls-top"
      />
      <LandingHeader />
      <LandingWelcome />
      <LandingCarousel />
      <LandingNeedHelp />
    </div>
  );
});

LandingPage.displayName = 'LandingPage';

export { LandingPage };
